import { Component, EventEmitter, Input, Output, computed, effect, input } from '@angular/core';
import { TableBtn, TableBtnRowClick, TableColumn, TableDataItem, TableItemValue, typeToCssClassMap, typeToIconMap } from './table.model';
import { positionCssMapper } from './constants';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {
  static uid = 0;
  uid: string = '';

  typeToIconMap = typeToIconMap
  typeToCssClassMap = typeToCssClassMap

  items = input<TableDataItem[]>([]);

  searchTerm = input<string>('');
  searchTermEf = effect(() => {
  });

  itemsToShow = computed(() => {
    return this.items().filter(item =>
      this.columns.some(col =>
        col.type === 'value' &&
        `${item[col.key]}`.toLowerCase().trim().includes(this.searchTerm().toLowerCase())
      )
    )
  });

  @Input() columns: TableColumn[] = [];
  @Input() showHeader: boolean = true;
  @Input() showBorder: boolean = false;
  @Input() tableDesign: '' | 'left-align' = '';
  @Input() enableSelectRow: boolean = false;
  @Input() fillEmptyRows: boolean = false;
  @Input() disabledBtnAction: boolean = false;
  @Input() hideBtnsOnDisabled?: boolean | string; // se true, btns desabilitados não são mostrados
  @Input() disableAllBtns = false;

  @Input() columnsSizes: null | string[] = null

  // todo, fazer com que em caso de check box, assim como já é feito nos botoes, cada item seja um objeto com valor e uma propriedade falando se está ou nao desabilitado
  @Input() disabledRows: number[] = [] // lista com os indices de inputs (atualmente só aceita checkbox) que vão ser desabilitados

  selectedOptionSelectField = null;

  @Output() checked = new EventEmitter<TableDataItem>();
  @Output() columnAction = new EventEmitter<string>();
  @Output() rowAction = new EventEmitter<TableBtnRowClick>();
  @Output() selected = new EventEmitter<string>();
  @Output() rowSelected = new EventEmitter<TableDataItem | null>();
  @Input() rowSelectedIndex: number | null = null;

  bodyContainerHeight: number = -1;
  minumRowsToAdd: any;
  resizeObs!: ResizeObserver;

  constructor() {
    TableComponent.uid += 1;
    this.uid = `${TableComponent.uid}`;
  }

  getInputLabel(item: TableDataItem, column: TableColumn) {
    return item[column.options?.inputLabelKey ?? ''] ?? ''
  }

  isValueDate(value: TableItemValue) {
    return value instanceof Date;
  }

  valueAsDate(value: TableItemValue) {
    if (this.isValueDate(value)) {
      return value as Date
    }
    return new Date()
  }

  parseValues(value: TableItemValue) {
    return `${value ?? '--'}`
  }

  asArray(x: TableItemValue) {
    if (Array.isArray(x)) {
      return x
    }
    return []
  }

  _checked(checkedItem: TableDataItem, selected: TableItemValue, column: TableColumn, indexItemChecked: number) {
    if (typeof selected !== 'boolean') { //por algum motivo essa função fica sendo chamada 2 vezes, mesmo o comp checkbox emitindo apenas 1
      return
    }
    if ((column.options?.inputUnique ?? true) && selected) {
      this.items().forEach((item, index) => {
        const isSelectedItem = indexItemChecked === index;
        item[column.key] = isSelectedItem;
      });
    }
    checkedItem[column.key] = selected;
    this.checked.emit(checkedItem);
  }

  _radioSelected(itemSelected: TableDataItem) {

    this.items().forEach(item => {
      item['cod'] !== itemSelected['cod'] ? item['selected'] = false : '';
    })
    itemSelected['selected'] = true;
    this.checked.emit(itemSelected);
  }

  applyHeaderDesign(column: TableColumn) {
    return { 'font-weight': 'bold' };
  }

  applyBodyDesign(column: TableColumn) {
    let newWidth = parseFloat(column.width ?? '30') - 15;
    return { 'min-width': newWidth + 'px' };
  }

  calcColumnContentJustification(column: TableColumn) {
    const defaultJust = column.key === 'date' ? 'center' : 'start'
    return positionCssMapper[column.options?.position ?? defaultJust]
  }

  calcWidth(column: TableColumn) {
    return {
      'width':
        `${column.options?.width}${column.options?.widthUnit === 'proportional' ? '%' : 'px'}`,
      display: 'flex',
      'justify-content': this.calcColumnContentJustification(column)
    }
  }

  setName(item: TableDataItem, index: number) {
    return `${this.uid}:${index}`;
  }

  _columnAction(columnKey: string) {
    if (!this.disabledBtnAction) {
      this.columnAction.emit(columnKey)
    }
  }

  _rowAction(item: TableDataItem, btn: TableBtn) {
    if (btn.disabled ?? false) {
      return
    }
    this.rowAction.emit({
      item,
      btn: btn.type
    })
  }

  _dateTypeConvert(item: TableItemValue) {
    if (item instanceof Date) {
      return {
        item,
        date: true as const
      }
    } else {
      return {
        item,
        date: false as const
      }
    }
  }

  selectedOption(itemSelected: any) {
    if (itemSelected) {
      this.selected.emit(itemSelected);
    }
  }

  onRowClick(item: TableDataItem, index: number) {

    if (!this.enableSelectRow) {
      return
    }
    if (this.rowSelectedIndex === index) {
      this.rowSelectedIndex = null;
      this.rowSelected.emit(null);

      return;
    }
    this.rowSelectedIndex = index;
    this.rowSelected.emit(item);
  }

  calcTextTransformStyle(col: TableColumn) {
    return {
      'text-transform': col.options?.textTransform ?? null
    }
  }

}

